import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  IoWarningOutline,
  IoCloseOutline,
  IoPencilOutline,
} from "react-icons/io5";
import { useQuery } from "@tanstack/react-query";
import { getMyLivepals } from "../backend/api/livepal";
import { getMyGearpals } from "../backend/api/gearlpal";
import { getProfile } from "../backend/api/auth";
import { useUserStore } from "../stores/UserStore";
import { LivePal, GearPal } from "../types/Pal";
import { useEditProfile } from "./providers/ModalsProvider"; // Import context hook

const NoContactAlert = () => {
  const { t, i18n } = useTranslation();
  const { user } = useUserStore();
  const [isVisible, setIsVisible] = useState(true);
  const { open: openEditProfile, isOpen: isEditProfileOpen } = useEditProfile();

  const { data: userProfile } = useQuery({
    queryKey: ["profile", i18n.language],
    queryFn: () => getProfile(i18n.language),
    enabled: !!user,
  });

  const { data: myLivePals } = useQuery({
    queryKey: ["my-livepals"],
    queryFn: () => getMyLivepals(i18n.language),
    enabled: !!user,
  });

  const { data: myGearPals } = useQuery({
    queryKey: ["my-gearpals"],
    queryFn: () => getMyGearpals(i18n.language),
    enabled: !!user,
  });

  if (!user || !isVisible || isEditProfileOpen) return null; // Added isEditProfileOpen check

  // If the user profile has contacts, we consider the user reachable, so no alert is needed.
  if (userProfile?.contacts && userProfile.contacts.length > 0) {
    return null;
  }

  const getPalsWithoutContacts = () => {
    const liveWithout =
      myLivePals?.filter(
        (pal: LivePal) =>
          (pal.contacts?.length === 0 || !pal.contacts) &&
          !pal.website &&
          !pal.email
      ) || [];

    const gearWithout =
      myGearPals?.filter(
        (pal: GearPal) => !pal.contacts || pal.contacts.length === 0
      ) || [];

    return [...liveWithout, ...gearWithout];
  };

  const palsWithoutContacts = getPalsWithoutContacts();

  if (palsWithoutContacts.length === 0) return null;

  const handleFixNow = () => {
    openEditProfile(); // Open profile edit modal
  };

  return (
    <div className="absolute top-20 left-1/2 -translate-x-1/2 z-[2000] w-[90%] max-w-2xl animate-fade-in-down">
      <div className="bg-secondary/90 backdrop-blur-md border border-white/20 rounded-2xl p-3 sm:p-4 shadow-2xl flex flex-col sm:flex-row items-center gap-3 sm:gap-4 group">
        <div className="flex items-center gap-3 flex-grow">
          <div className="p-2 bg-white/20 rounded-xl shrink-0">
            <IoWarningOutline className="text-white w-5 h-5 sm:w-6 sm:h-6" />
          </div>
          <p className="text-white text-xs sm:text-sm font-medium leading-tight">
            {t(
              "errors.missingContactAlert",
              "Attenzione: alcuni dei tuoi Pal non hanno contatti inseriti. Gli altri utenti non potranno contattarti!"
            )}
          </p>
        </div>

        <div className="flex items-center gap-2 w-full sm:w-auto">
          <button
            onClick={handleFixNow}
            className="flex-grow sm:flex-none flex items-center justify-center gap-2 px-4 py-2 bg-white text-secondary rounded-xl text-xs sm:text-sm font-bold hover:bg-white/90 transition-all shadow-lg active:scale-95"
          >
            <IoPencilOutline size={16} />
            {t("common.fixNow", "Rimedia ora")}
          </button>

          {/*<button*/}
          {/*  onClick={() => setIsVisible(false)}*/}
          {/*  className="p-2 hover:bg-white/10 rounded-xl transition-colors shrink-0"*/}
          {/*>*/}
          {/*  <IoCloseOutline className="text-white w-5 h-5 sm:w-6 sm:h-6" />*/}
          {/*</button>*/}
        </div>
      </div>
    </div>
  );
};

export default NoContactAlert;
